import { Text } from '@lounge-fe/ui-kit'
import { Money } from '@/components/Money'
import { useShopify } from '@/hooks/useShopify'
import { CurrencyCode } from '@shopify/hydrogen-react/storefront-api-types'
import { TextVariant } from '@lounge-fe/ui-kit/src/components/Text/types'

export const Price = ({
  price,
  compareAtPrice,
  variant = 'title-five',
}: PriceProps) => {
  const { currency } = useShopify()

  return (
    <div className="flex gap-2">
      <Money
        variant={variant}
        className="text-[#888888]"
        as={Text}
        data={{
          amount: price.toString(),
          currencyCode: (currency.active as CurrencyCode) ?? 'GBP',
        }}
      />
      {compareAtPrice && (
        <Money
          variant={variant}
          className="line-through text-[#B0B0B0]"
          as={Text}
          data={{
            amount: compareAtPrice.toString(),
            currencyCode: (currency.active as CurrencyCode) ?? 'GBP',
          }}
        />
      )}
    </div>
  )
}

interface PriceProps {
  price: number
  compareAtPrice?: number | null
  variant?: TextVariant
}
